import { render, staticRenderFns } from "./SearchTransferPartial.vue?vue&type=template&id=31bc58b5&scoped=true"
import script from "./SearchTransferPartial.vue?vue&type=script&lang=js"
export * from "./SearchTransferPartial.vue?vue&type=script&lang=js"
import style0 from "./SearchTransferPartial.vue?vue&type=style&index=0&id=31bc58b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc58b5",
  null
  
)

export default component.exports